import { AvailableReadProviders } from '@ankr.com/provider';

import { IS_PROD } from 'modules/common/constants/env';

export const getEthReadProviderID = () => {
  if (IS_PROD) {
    return AvailableReadProviders.ethMainnet;
  }

  return AvailableReadProviders.ethHolesky;
};
